<template src="./html/Create.html"></template>

<script>
	import Multiselect from 'vue-multiselect'
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import PlaceCreate from './../../places/views/Create.vue'
	import DepartmentModal from './../../../departments/views/Modal.vue'

	export default {
		props: ['user', 'isAuth', 'project', 'staff', 'order'],
		components: {
			'multiselect': Multiselect,
			'place-create': PlaceCreate,
			'department-modal': DepartmentModal,
		},
		data () {
			return {
				projectResource: null,
				modal: {
					selector: 'modal-create-task',
				},

				projects: null,
				department:null,
				departments: null,
				prioritylevels: null,

				addToSchedule: true,

				options: [],
				isLoading: false,

				item: {
					order_id: null,
					project: null,
					notification: false,
					customer: null,
					places: [],
					store_place: null,
					users: [],
					name: null,
					priority_level_id: null,
					description: null,
					set_time: null,
					auto_end: this.$platform.setting.tasks.auto_end,
					auto_closing: this.$platform.setting.tasks.auto_closing,
				},

				set_time: {
					hours: null,
					minutes: null,
				}
			}
		},
		created () {
			$('[data-toggle="popover"]').popover()
			this.init()
		},
		watch: {
			'item.project': function() {
				if(this.item.project) {
					this.projectResource = 'admin/projects/projects/' + this.item.project.id
					if(this.item.project.customers) {
						this.item.customer = this.item.project.customers[0]
					}
				}
			},
			'set_time.hours'() {
				if(this.set_time.hours) {
					this.set_time.hours = parseInt(this.set_time.hours)
				} else {
					this.set_time.hours = null
				}
				this.calculateSeconds()
			},
			'set_time.minutes'() {
				if(this.set_time.minutes) {
					this.set_time.minutes = parseInt(this.set_time.minutes)
					if(this.set_time.minutes > 59) {
						this.set_time.minutes = 59
					}
				} else {
					this.set_time.minutes = null
				}
				this.calculateSeconds()
			},
		},
		methods: {
			reload(data) {
				if(data.place) {
					this.item.project.places.push(data.place)
					this.item.places.push(data.place)
				}
			},
			init() {
				this.getProjects()
				if(!this.user.hasRole('external_manager')) {
					this.getDepartments()
				}
				this.getPriorityLevels()
			},
			open(project, user, place, order) {
				if(project) {
					this.item.project = project
					this.projects = [project]
				}
				if(user) {
					this.item.users.push(user)
				}
				this.item.order_id = null
				if(order) {
					this.item.order_id = order.id
				}
				
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			getProjects() {
				this.$http.get('admin/projects/projects')
					.then(response => {
						this.projects = response.body
					})
			},
			getDepartments() {
				this.$http.get('admin/departments/status/2')
					.then(response => {
						this.departments = response.body
					})
			},
			getPriorityLevels() {
				this.$http.get('admin/projects/prioritylevels')
					.then(response => {
						this.prioritylevels = response.body
						if(this.prioritylevels.length) {
							this.item.priority_level_id = this.prioritylevels[0].id
						}
					})
			},
			dateUnavailable (unavailable) {
				if(unavailable.length) {
					for (var i = 0; i < unavailable.length; i++) {
						var element = unavailable[i]
						var start = moment(element.start_date)
						var end = moment(element.end_date)
						if(moment().isBetween(start, end)) {
							return start.format('DD/MM/YYYY - H:mm') + ' | ' + end.format('DD/MM/YYYY - H:mm')
						}
					}
				}
			},
			typeUnavailable(unavailable) {
				if(unavailable.length) {
					for (var i = 0; i < unavailable.length; i++) {
						var element = unavailable[i]
						var start = moment(element.start_date)
						var end = moment(element.end_date)
						if(moment().isBetween(start, end)) {
							return element.type
						}
					}
				}
			},
			openPopoverDate(id) {
				var popover = $('#popover-'+id)
				popover.popover('toggle')
			},
			parseUsersMultiselect() {
				var users = []
				for (var i = 0; i < this.users.length; i++) {
					users.push({
						value: this.users[i].id,
						label: this.users[i].profile.first_name
					})
				}
				this.users = users
			},
			getTasksByUser() {
				if(this.item.users) {
					var users_id = []
					for (var i = 0; i < this.item.users.length; i++) {
						users_id.push(this.item.users[i].value)
					}
					var data = {
						task_status: [2],
						users_id: users_id
					}
					if(users_id.length) {
						this.$http.post('admin/users/tasks', data)
						.then(response => {
							this.tasks_users = response.body
						}).catch(function(response) {
							console.log(response)
						})
					}
				}
			},
			clearData () {
				this.item.customer = null
				this.item.description = null
				this.item.set_time = null
				this.item.name = null
				this.item.priority_level_id = 1
				this.item.project = null
				this.item.users = []
				this.item.places = []
			},
			editContinue(id, data) {
				this.clearData()
				var that = this
				if(this.user.hasRole('staff')) {
					swal({
						title: data.body.title,
						text: data.body.text,
						type: data.body.type,
					})
				} else {
					swal({
						title: data.body.title,
						text: data.body.text,
						type: data.body.type,
						showCancelButton: true,
						confirmButtonColor: '#2cabe3',
						confirmButtonText: 'Editar tarea',
						cancelButtonText: 'Continuar',
					}).then(function () {
						that.close()
						that.$router.push('/' + this.$platform.slug + '/' + that.$i18n.locale + '/admin/projects/tasks/'+id+'/edit')
					}).catch(function() {
						that.close()
					})
				}
			},
			notification(id, response) {
				var that = this
				swal({
					title: this.$t("messages.notify"),
					text: this.$t("messages.notify_the_task_staff_by_email"),
					type: 'info',
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function () {
							that.$http.get('admin/projects/tasks/'+id+'/notification/mail')
								.then(response => {
									if(response.body) {
										that.$emit('reload')
										that.item.locked = response.body.locked
										that.item.trace = response.body.trace

										swal({
											title: that.$t("messages.done"),
											text: that.$t("messages.notifications_sent_correctly"),
											type: 'success',
											showCancelButton: true,
											confirmButtonColor: '#2cabe3',
											confirmButtonText: 'Editar tarea',
											cancelButtonText: 'Continuar',
										}).then(function () {
											that.close()
											that.$router.push('/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/projects/tasks/'+id+'/edit')
										}).catch(function() {
											that.close()
										})
									}
								}).catch(function(response) {
									console.log(response)
								})
						})
					}
				}).catch(function() {
					that.editContinue(id, response)
				})
			},
			goStore() {
				var element = $(event.target)
				if(element.is('input')) {
					this.store()
				}
			},
			store() {
				if(this.item.project && this.item.name && this.item.priority_level_id) {
					var loading = Ladda.create(this.$refs.btnStore);
					loading.start();
					this.$http.post('admin/projects/tasks', this.item)
					.then(response => {
						loading.stop()
						this.task = response.body.data
						this.$emit('reload')
						var that = this;
						this.clearData()

						if(that.addToSchedule) {
							swal({
								title: response.body.title,
								text: response.body.text,
								type: response.body.type,
								allowEscapeKey: false
							}).then(function () {
								that.close()
								that.$emit('openCreateSchedule', that.task)
							}).catch(function() {
								that.close()
							})
						} else {
							if(that.item.users.length) {
								that.notification(that.task.id, response)
							} else {
								this.close()
								this.editContinue(that.task.id, response)
							}
						}

						this.clearData()
					}).catch(function(response) {
						console.log(response)
						loading.stop()
					})
				}
			},
			search(query) {
				if(query) {
					this.isLoading = true
					var data = {
						query: query,
						filter: {
							department_id: null,
							team_id: null,
						}
					}

					if(this.item.project) {
						data.filter.team_id = this.item.project.team_id
					}

					if(this.department) {
						data.filter.department_id = this.department.id
					}

					this.$http.post('admin/users/search', data)
					.then(response => {
						this.isLoading = false
						this.options = response.body
					}).catch(function(response) {
						this.isLoading = false
						console.log(response)
					})
				}
			},
			getSeconds(value, string) {
				var time = parseInt(value)
				if(time) {
					var seconds = moment.duration().add(value, string).asSeconds()
				} else {
					var seconds = 0
				}
				return seconds
			},
			calculateSeconds() {
				if(this.set_time.hours) {
					var secondsHours = this.getSeconds(this.set_time.hours, 'hours')
				} else {
					var secondsHours = 0
				}

				if(this.set_time.minutes) {
					var secondsMinutes = this.getSeconds(this.set_time.minutes, 'minutes')
				} else {
					var secondsMinutes = 0
				}
				this.item.set_time = secondsHours + secondsMinutes
			}
		},
		mounted() {
			var that = this
			$('#' + this.modal.selector).on('hidden.bs.modal', function () {
				that.clearData()
			})
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/projects/tasks/views/Create.vue